import { Link } from "react-router-dom";

interface StarsProps {
  rating: number;
  size?: "sm" | "md";
  showValue?: boolean;
}

export default function Stars({ rating, size = "sm", showValue = true }: StarsProps) {
  const full = Math.floor(rating);
  const hasHalf = rating - full >= 0.25 && rating - full < 0.75;
  const fullStars = rating - full >= 0.75 ? full + 1 : full;
  const px = size === "sm" ? "text-xs" : "text-sm";

  return (
    <div className="flex items-center gap-1">
      <div className={`flex items-center text-accent-500 ${px} leading-none`}>
        {Array.from({ length: 5 }).map((_, i) => {
          let cls = "ri-star-line text-background-300";
          if (i < fullStars) cls = "ri-star-fill";
          else if (i === fullStars && hasHalf) cls = "ri-star-half-fill";
          return (
            <span key={i} className="w-3.5 h-3.5 flex items-center justify-center">
              <i className={cls} />
            </span>
          );
        })}
      </div>
      {showValue && (
        <span className="font-label font-semibold text-foreground-800 tabular-nums">
          {rating.toFixed(1)}
        </span>
      )}
    </div>
  );
}

export function KindBadge({ kind }: { kind: "movie" | "tv" }) {
  return (
    <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-background-100 text-foreground-600 border border-background-200">
      {kind === "movie" ? "电影" : "剧集"}
    </span>
  );
}

export function SectionTitle({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
  accentLabel,
}: {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  accentLabel?: string;
}) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        {accentLabel && (
          <span className="inline-flex items-center gap-1.5 text-[11px] font-label tracking-[0.18em] uppercase text-accent-600 mb-2">
            <span className="w-4 h-px bg-accent-500" />
            {accentLabel}
          </span>
        )}
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 tracking-tight">
          {title}
        </h2>
        {subtitle && (
          <p className="text-sm text-foreground-500 mt-1.5 max-w-2xl">{subtitle}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer shrink-0"
        >
          {moreLabel}
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
        </Link>
      )}
    </div>
  );
}